import { createSlice } from '@reduxjs/toolkit'
import { layoutTypes } from '../../constants/layout'

const initialState = {
  layoutType: layoutTypes.VERTICAL,
}

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    changeLayout: (state, action) => {
      state.layoutType = action.payload
    },
  },
})

export const { changeLayout } = layoutSlice.actions
export default layoutSlice.reducer
